(function () {
  const DEFAULT_FULL_WEEKLY_HOURS = 37.5;
  const WEEKS_PER_YEAR = 52;
  const MONTHS_PER_YEAR = 12;
  const DEFAULT_FULL_ANNUAL_HOURS = DEFAULT_FULL_WEEKLY_HOURS * WEEKS_PER_YEAR;
  const DEFAULT_FULL_MONTHLY_HOURS = DEFAULT_FULL_ANNUAL_HOURS / MONTHS_PER_YEAR;

  const number = (value, fallback = 0) => {
    const match = String(value ?? '').replace(',', '.').match(/-?\d+(?:\.\d+)?/);
    if (!match) return fallback;
    const parsed = Number(match[0]);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const round = (value, decimals = 2) => {
    const factor = 10 ** decimals;
    return Math.round((Number(value) || 0) * factor) / factor;
  };

  const format = (value, decimals = 1) => {
    const fixed = round(value, decimals).toLocaleString('nb-NO', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    return fixed.replace(',0', '');
  };

  const normalizeScope = (value) => (value === 'part_time' ? 'part_time' : 'full_time');
  const normalizeHoursPeriod = (value) => (value === 'month' ? 'month' : 'week');

  const normalizeDraft = (draft = {}) => {
    const employmentScope = normalizeScope(draft.employmentScope);
    if (employmentScope !== 'part_time') {
      return {
        employmentScope: 'full_time',
        hoursPeriod: 'week',
        weeklyHours: DEFAULT_FULL_WEEKLY_HOURS,
        monthlyHours: DEFAULT_FULL_MONTHLY_HOURS,
        annualHours: DEFAULT_FULL_ANNUAL_HOURS,
        positionPercent: 100,
      };
    }

    const hoursPeriod = normalizeHoursPeriod(draft.hoursPeriod);
    const rawWeekly = number(draft.weeklyHours, 0);
    const rawMonthly = number(draft.monthlyHours, 0);
    const weeklyHours = hoursPeriod === 'month'
      ? round((rawMonthly || DEFAULT_FULL_MONTHLY_HOURS) * MONTHS_PER_YEAR / WEEKS_PER_YEAR)
      : round(rawWeekly || DEFAULT_FULL_WEEKLY_HOURS);
    const monthlyHours = hoursPeriod === 'month'
      ? round(rawMonthly || weeklyHours * WEEKS_PER_YEAR / MONTHS_PER_YEAR)
      : round(weeklyHours * WEEKS_PER_YEAR / MONTHS_PER_YEAR);
    const annualHours = round(hoursPeriod === 'month' ? monthlyHours * MONTHS_PER_YEAR : weeklyHours * WEEKS_PER_YEAR);
    const positionPercent = round((weeklyHours / DEFAULT_FULL_WEEKLY_HOURS) * 100, 1);

    return {
      employmentScope,
      hoursPeriod,
      weeklyHours,
      monthlyHours,
      annualHours,
      positionPercent,
    };
  };

  const fromEmployee = (employee = {}) => {
    const backend = employee._backend || employee || {};
    const arbeidsforhold = employee.arbeidsforhold || {};
    const storedScope = normalizeScope(backend.employmentScope);
    const positionPercent = number(backend.positionPercent ?? arbeidsforhold.stillingsprosent, 100);
    const weeklyHours = number(backend.agreedHoursPerWeek ?? backend.weeklyHours ?? arbeidsforhold.timer, DEFAULT_FULL_WEEKLY_HOURS);
    const monthlyHours = number(
      backend.agreedHoursPerMonth ?? backend.monthlyHours,
      round(weeklyHours * WEEKS_PER_YEAR / MONTHS_PER_YEAR),
    );
    const inferredScope = positionPercent < 99.95 || weeklyHours < DEFAULT_FULL_WEEKLY_HOURS - 0.01 || monthlyHours < DEFAULT_FULL_MONTHLY_HOURS - 0.01
      ? 'part_time'
      : storedScope;

    return normalizeDraft({
      employmentScope: backend.employmentScope ? storedScope : inferredScope,
      hoursPeriod: backend.agreedHoursPeriod || backend.hoursPeriod || 'week',
      weeklyHours,
      monthlyHours,
    });
  };

  const toBackendPatch = (scope = {}) => {
    const normalized = normalizeDraft(scope);
    return {
      employmentScope: normalized.employmentScope,
      agreedHoursPeriod: normalized.hoursPeriod,
      agreedHoursPerWeek: normalized.weeklyHours,
      agreedHoursPerMonth: normalized.monthlyHours,
      monthlyHours: normalized.monthlyHours,
      weeklyHours: normalized.weeklyHours,
      positionPercent: normalized.positionPercent,
    };
  };

  const annualSalary = ({ mode, value, scope } = {}) => {
    const amount = Number(value) || 0;
    if (mode === 'arslonn') return Math.round(amount);
    return Math.round(amount * normalizeDraft(scope).annualHours);
  };

  const summary = (scope = {}) => {
    const normalized = normalizeDraft(scope);
    if (normalized.employmentScope === 'full_time') return 'Heltid - 1 950 timer/år (37,5 t/uke).';
    return `Deltid - ${format(normalized.annualHours, 0)} timer/år (${format(normalized.weeklyHours)} t/uke / ${format(normalized.monthlyHours)} t/mnd).`;
  };

  const api = {
    DEFAULT_FULL_WEEKLY_HOURS,
    DEFAULT_FULL_MONTHLY_HOURS,
    DEFAULT_FULL_ANNUAL_HOURS,
    normalizeDraft,
    fromEmployee,
    toBackendPatch,
    annualSalary,
    summary,
  };

  Object.assign(window, { PlummePayrollEmploymentScope: api });
}());
